const KEYBOARD_ELEMENT_ID = "keyboard";
const KEYBOARD_SCROLL_CONTAINER_CLASS = "scroll-container";
const KEYBOARD_SCROLL_TRACK_CLASS = "scroll-track";
const KEYBOARD_SCROLL_HAS_PREVIOUS_CLASS = "has-previous";
const KEYBOARD_SCROLL_HAS_NEXT_CLASS = "has-next";

/**
 * observes keyboard scroll and adds/removes
 * has-previous, has-next classes
 */
export function setupKeyboardScrollIndicators() {
    const keyboard = document.getElementById(KEYBOARD_ELEMENT_ID);

    if (!keyboard) {
        throw Error(`cannot find keyboard element (#${KEYBOARD_ELEMENT_ID})`);
    }

    const scrollContainer = keyboard.querySelector(
        `.${KEYBOARD_SCROLL_CONTAINER_CLASS}`
    );

    if (!scrollContainer) {
        throw Error("cannot find keyboard scroll container");
    }

    const scrollTrack = keyboard.querySelector(
        `.${KEYBOARD_SCROLL_TRACK_CLASS}`
    );

    if (!scrollTrack) {
        throw Error("cannot find keyboard scroll track");
    }

    function recomputeScrollIndicators() {
        const marginOfError = 4;
        const trackWidth = scrollTrack.getBoundingClientRect().width;
        const hasPrevious = scrollContainer.scrollLeft > marginOfError;
        const hasNext =
            scrollContainer.scrollLeft <
            trackWidth -
                scrollContainer.getBoundingClientRect().width -
                marginOfError;

        if (hasPrevious) {
            keyboard.classList.add(KEYBOARD_SCROLL_HAS_PREVIOUS_CLASS);
        } else {
            keyboard.classList.remove(KEYBOARD_SCROLL_HAS_PREVIOUS_CLASS);
        }

        if (hasNext) {
            keyboard.classList.add(KEYBOARD_SCROLL_HAS_NEXT_CLASS);
        } else {
            keyboard.classList.remove(KEYBOARD_SCROLL_HAS_NEXT_CLASS);
        }
    }

    scrollContainer.addEventListener("scroll", recomputeScrollIndicators);
    window.addEventListener("resize", recomputeScrollIndicators);
    recomputeScrollIndicators();
}
